// What the game view's section tabs need that is not drawing: the ids a tab and its panel give each other, and where a key
// press moves focus. P6-334 (GN-7), GN-3b's concern 11.
//
// Pure, so the pattern is asserted without a keyboard and the component is only the wiring. The pattern is WAI-ARIA's tabs
// with automatic activation (the APG's "Tabs" example): Left and Right move to the neighbour and wrap, Home and End go to
// the ends, the selected tab alone is in the tab order, and selection follows focus. `chartMath.js`'s `KEY_STEP` is a
// slider's (one step along a series) and is not this.

/** The id of a section's tab. One game view is mounted at a time, so the section's key is the whole name. */
export const tabId = (key) => `d2d-hoops-tab-${key}`

/** The id of a section's panel: what its tab's `aria-controls` names. */
export const panelId = (key) => `d2d-hoops-panel-${key}`

/**
 * The index a key moves focus to, or `null` for a key that is not a tablist's.
 *
 * `index` is the tab that has focus and `count` how many there are. Right on the last tab is the first and Left on the
 * first is the last (the tabs wrap); Home is the first and End the last whatever has focus. Up and Down are not here: the
 * strip is horizontal, and the vertical arrows are the page's.
 */
export function tabTarget(key, index, count) {
  if (!Number.isInteger(count) || count < 1) return null
  if (key === 'ArrowRight') return (index + 1) % count
  if (key === 'ArrowLeft') return (index - 1 + count) % count
  if (key === 'Home') return 0
  if (key === 'End') return count - 1
  return null
}

/**
 * Does a key press with these modifiers belong to the tabs? A modifier means the browser's own shortcut (Alt+Left is Back,
 * Cmd+Left is Back on a Mac, Ctrl+Home is the top of the page) and is left alone.
 */
export function isPlainKey(event) {
  return !(event.altKey || event.ctrlKey || event.metaKey || event.shiftKey)
}
